import { CheckCircle, InfoRounded, Close, Cancel, HelpOutline } from '@material-ui/icons';
import { SnackbarContent, Tooltip, withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import styles from '../ModuleAssessmentCard.module.css';
import Loader from 'features/chatAssist/components/Loader/Loader';
const useStylesBase = makeStyles({
  root: {
    boxShadow: 'none',
    padding: '1px 12px',
    marginBottom: '1rem',
    flexWrap: 'nowrap',
    width: '100% !important',
    boxSizing: 'border-box',
  },
});

const useStylesLoading = makeStyles({
  root: {
    backgroundColor: '#ECF7FF',
    border: '1px solid  #0494FD',
    color: '#0494FD',
  },
});

const useStylesSuccess = makeStyles({
  root: {
    backgroundColor: 'rgba(240, 255, 250, 1)',
    border: '1px solid  rgba(45, 195, 141, 1)',
    color: 'rgba(45, 195, 141, 1)',
  },
});

const useStylesFail = makeStyles({
  root: {
    backgroundColor: 'rgba(255, 247, 247, 1)',
    border: '1px solid  rgba(232, 58, 58, 1)',
    color: 'rgba(232, 58, 58, 1)',
  },
});

const Snackbars = ({
  status = 'IN_PROGRESS',
  onReGenerate = () => null,
  onTryAgain = () => null,
  onClose = () => null,
  isLoading = false,
  msg = '',
}) => {
  const classesBase = useStylesBase();
  const classesLoading = useStylesLoading();
  const classesSuccess = useStylesSuccess();
  const classesFail = useStylesFail();

  const TooltipStyled = withStyles(() => ({
    tooltip: {
      backgroundColor: 'black',
      color: 'white',
    },
    arrow: {
      color: 'black',
    },
  }))(Tooltip);

  const loadingAction = (
    <div className={styles.action} onClick={onClose}>
      <Close fontSize="small" />
    </div>
  );

  const actionFail = (
    <div className={styles.action} onClick={onTryAgain}>
      {isLoading ? <Loader /> : <span>Try Again</span>}
    </div>
  );

  const action = (
    <div className={styles.action} onClick={onReGenerate}>
      {isLoading ? <Loader /> : <span>Re-generate Quiz</span>}
    </div>
  );

  if (status === 'PARTIAL_SUCCESS' || status === 'SUCCEEDED')
    return (
      <SnackbarContent
        className={classNames(classesBase.root, classesSuccess.root)}
        message={
          <div className={styles.message}>
            <CheckCircle fontSize="small" />
            <div>
              {status === 'SUCCEEDED'
                ? 'AI has generated multiple choice questions successfully'
                : 'Quiz generated, but AI couldn’t reach the whole contents of this module.'}
            </div>
          </div>
        }
        action={action}
      />
    );

  if (status === 'FAILED')
    return (
      <SnackbarContent
        className={classNames(classesBase.root, classesFail.root)}
        message={
          <div className={styles.message}>
            <Cancel fontSize="small" />
            <div>AI Assistant couldn’t generate module quiz.</div>
            <TooltipStyled title={msg} arrow placement="top">
              <HelpOutline style={{ fontSize: '1rem', color: 'grey' }} />
            </TooltipStyled>
          </div>
        }
        action={actionFail}
      />
    );

  if (status === 'IN_PROGRESS' || status === 'QUEUED')
    return (
      <SnackbarContent
        className={classNames(classesBase.root, classesLoading.root)}
        message={
          <div className={styles.message}>
            <InfoRounded fontSize="small" />
            <div>AI is generating this module based assessment content.</div>
          </div>
        }
        action={loadingAction}
      />
    );
  return null;
};

export default Snackbars;
